export class Role {
  isDefaultRole: boolean;
  name: string;
  numClients: number;
  numContributor: number;
  permissions: string[];
  properties: {}
  _links: {}
}
